import React from "react";
import { FIELD_OPTIONS } from "../fieldOptions";

export default function FieldSelect({ entityType, field, setField }) {
  const options = FIELD_OPTIONS[entityType] || [{ value: "any", label: "Все поля" }];

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "0.25rem" }}>
      <label style={{ fontSize: "0.8rem", color: "#64748b" }}>Поле</label>
      <select
        value={field}
        onChange={(e) => setField(e.target.value)}
        style={{
          padding: "0.45rem 0.6rem",
          borderRadius: "0.5rem",
          border: "1px solid #e2e8f0",
          fontSize: "0.9rem",
          outline: "none",
        }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
}
